<template>
  <div
    id="editor"
    class="relative z-0 w-full py-3"
  >
    <span class="absolute text-gray-500 transform scale-75 -top-3 origin-0">
      {{ "InputLabel_EnterDesc" | i18n }}
    </span>

    <editor-menu-bar
      v-slot="{ commands, isActive }"
      :editor="editor"
    >
      <div class="flex items-center space-x-2 md:space-x-5">
        <button
          class="font-bold"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          B
        </button>

        <button
          class="italic"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          I
        </button>

        <button
          class="line-throughunderline"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          S
        </button>

        <button
          class="underline"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          U
        </button>

        <span class="h-5 border-r-2 border-gray-200" />

        <button
          class=""
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >
          H1
        </button>

        <button
          class=""
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          H2
        </button>

        <button
          class=""
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          H3
        </button>

        <span class="h-5 border-r-2 border-gray-200" />

        <button
          class=""
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="w-4 h-4 bi bi-list-ul"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            />
          </svg>
        </button>

        <button
          class=""
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="w-4 h-4 bi bi-list-ol"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5z"
            />
            <path
              d="M1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 0 1-.492.594v.033a.615.615 0 0 1 .569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 0 0-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z"
            />
          </svg>
        </button>

        <span class="h-5 border-r-2 border-gray-200" />

        <button
          class=""
          @click="commands.undo"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              d="M 2.5 8 C 2.372 8 2.2439844 8.0489844 2.1464844 8.1464844 C 2.0484844 8.2434844 2 8.372 2 8.5 L 2 15 A 1 1 0 0 0 3 16 L 9.5 16 C 9.628 16 9.7555156 15.950516 9.8535156 15.853516 C 10.048516 15.658516 10.048516 15.341484 9.8535156 15.146484 L 7.2207031 12.513672 C 8.6282801 11.265495 10.470063 10.5 12.5 10.5 C 15.649 10.5 18.367875 12.32275 19.671875 14.96875 C 19.947875 15.52875 20.588641 15.803469 21.181641 15.605469 C 21.890641 15.369469 22.250875 14.559672 21.921875 13.888672 C 20.215875 10.403672 16.643 8 12.5 8 C 9.7794954 8 7.3175698 9.0503139 5.4570312 10.75 L 2.8535156 8.1464844 C 2.7560156 8.0489844 2.628 8 2.5 8 z"
            />
          </svg>
        </button>

        <button
          class=""
          @click="commands.redo"
        >
          <svg
            class="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path
              d="M 11.5 8 C 7.257 8 3.6110312 10.520531 1.9570312 14.144531 C 1.7090313 14.687531 1.9847813 15.328578 2.5507812 15.517578 C 3.0297813 15.677578 3.5527188 15.452188 3.7617188 14.992188 C 5.0977187 12.048188 8.057 10 11.5 10 C 13.678099 10 15.656912 10.829684 17.160156 12.177734 L 14.191406 15.146484 C 13.996406 15.341484 13.996406 15.658516 14.191406 15.853516 C 14.289406 15.950516 14.416922 16 14.544922 16 L 21.044922 16 A 1 1 0 0 0 22.044922 15 L 22.044922 8.5 C 22.044922 8.372 21.996437 8.2434844 21.898438 8.1464844 C 21.703437 7.9514844 21.386406 7.9514844 21.191406 8.1464844 L 18.568359 10.769531 C 16.705156 9.0570281 14.232024 8 11.5 8 z"
            />
          </svg>
        </button>
      </div>
    </editor-menu-bar>

    <editor-content
      class="block w-full px-0 py-2 mt-0 bg-transparent border-0 border-b-2 border-gray-200 appearance-none focus-within:outline-none focus-within:ring-0 focus-within:border-black"
      :editor="editor"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
import {
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Link,
  Strike,
  Underline,
  History
} from "tiptap-extensions";

export default {
  name: "Editor",

  components: { EditorContent, EditorMenuBar },

  emits: ["update-desc"],

  data() {
    return {
      editor: new Editor({
        extensions: [
          new Heading({
            levels: [1, 2, 3]
          }),
          new Bold(),
          new Italic(),
          new Strike(),
          new Underline(),
          new Link(),
          new ListItem(),
          new BulletList(),
          new OrderedList(),
          new History()
        ],
        content: ``,
        onUpdate: ({ getHTML }) => {
          const html = getHTML();
          this.$emit("update-desc", html);
        }
      })
    };
  },

  computed: {
    ...mapGetters(["editorContent"])
  },

  watch: {
    editorContent(html) {
      this.setContent(html);
    }
  },

  beforeDestroy() {
    this.editor.destroy();
  },

  methods: {
    clearContent() {
      this.editor.clearContent(true);
      this.editor.focus();
    },
    setContent(html) {
      this.editor.setContent(html);
      this.editor.focus();
    }
  }
};
</script>
